import { Button } from "grabcad-ui-elements";
import { Banner, BannerContent, BannerIcon } from "./InfoBannerStyle";
import { useContext } from "react";
import { ApplicationContext } from "../../components/ApplicationProvider";
import Parser from "html-react-parser";
import { contactUsURL } from "../../utils/constants";

export const InfoBanner = () => {
    const { t } = useContext(ApplicationContext);
    return (
        <Banner>
            <BannerContent>
                <BannerIcon size="large" name="info circle" />
                {Parser(
                    t("licenses_overview.download_license_file_prerequisite.instruction", {
                        contactUsURL,
                    })
                )}
            </BannerContent>
            <Button onClick={() => window.open(contactUsURL, "_blank")}>
                {t("licenses_overview.download_license_file_prerequisite.get_streamline_pro")}
            </Button>
        </Banner>
    );
};
